import React from 'react'
import {useSelector} from 'react-redux'

import {Button} from '@daedalus/atlas/Button'
import {useDeviceLayout} from '@daedalus/atlas/context/deviceLayout'
import {Box} from '@daedalus/atlas/helpers/Box'
import {Icon} from '@daedalus/atlas/Icon'
import {getAnonymousId} from '@daedalus/core/src/_web/anonymousId'
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage'
import {getApplication} from '@daedalus/shared/src/dealFreeze/modules/selector'
import {
  getBookingManagementUrl,
  getDealFreezePaymentUrl
} from '@daedalus/shared/src/dealFreeze/utils/url'

interface Props {
  bookingId: string
}

export const FrozenRoomOfferCTA: React.FC<Props> = ({bookingId}) => {
  const {isMobile} = useDeviceLayout()
  const {bookingManagementUrl, checkoutUrl} = useSelector(getApplication)
  const anonymousId = getAnonymousId() as string
  const bookingUrl = getBookingManagementUrl({
    hostUrl: bookingManagementUrl,
    bookingId,
    anonymousId
  })
  const paymentUrl = getDealFreezePaymentUrl({
    hostUrl: checkoutUrl,
    bookingId
  })

  const handleManageBooking = (event: React.SyntheticEvent) => {
    event.preventDefault()
    event.stopPropagation()

    if (bookingManagementUrl && bookingId) window.location.href = bookingUrl
  }

  const handleCompleteBooking = (event: React.SyntheticEvent) => {
    event.preventDefault()
    event.stopPropagation()

    if (checkoutUrl && bookingId) window.location.href = paymentUrl
  }
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems={isMobile ? 'flex-start' : 'center'}
      flexDirection={isMobile ? 'row' : 'column-reverse'}
      gap="s400"
    >
      <Box width={isMobile ? 'auto' : '100%'}>
        <Button
          size="lg"
          variant="special"
          fullWidth
          onClick={handleManageBooking}
        >
          <FormattedMessageWrapper
            id="df.manageFreezeButton"
            defaultMessage="Manage"
          />
        </Button>
      </Box>
      <Button
        size="lg"
        variant="primary"
        fullWidth
        iconEnd={<Icon name="ChevronRight" />}
        onClick={handleCompleteBooking}
      >
        <FormattedMessageWrapper
          id="dealFreeze.completeBooking"
          defaultMessage="Complete booking"
        />
      </Button>
    </Box>
  )
}
